import React from 'react';
import { Form } from "semantic-ui-react";
import { useFormik } from 'formik';
import { Level } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./LevelForm.form";

const levelController = new Level();

export function LevelForm(props) {

  const { onClose, onReload, level } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(level),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          name: formValue.name,
        };

        if (level) {
          await levelController.updateLevel(accessToken, level.id, data);
        } else {
          data.status = 1;
          await levelController.createLevel(accessToken, data);
        }
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Input
        name="name"
        label="Nombre del nivel"
        onChange={formik.handleChange}
        value={formik.values.name}
        error={formik.errors.name}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {level ? "Actualizar nivel" : "Crear nivel"}
      </Form.Button>
    </Form>
  )
}
